import { BackButton } from '@apps/attention360/atoms';
import { Center, Heading, SkeletonText, Stack, Text, VStack } from '@chakra-ui/react';
import { routing } from '@configs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export interface CampaignHeaderSectionProps {
    title: string;
    subtitle?: string;
    lastModified?: Date;
    isLoading?: boolean;
}

export const CampaignHeaderSection: FC<CampaignHeaderSectionProps> = ({
    title,
    subtitle,
    lastModified,
    isLoading,
}) => {
    const { t } = useTranslation('mediaPlans');

    return (
        <Stack direction="row">
            <BackButton route="../"/>

            <VStack
                minW="8rem"
                overflowX="hidden"
                align="left"
                spacing={0}
                marginRight="1rem"
                minH="3.125rem"
            >
                {isLoading ? (
                    <Center marginTop="0.5rem">
                        <SkeletonText width="15rem" noOfLines={2} />
                    </Center>
                ) : (
                    <>
                        <Heading textOverflow="ellipsis" whiteSpace="nowrap" overflow="hidden">
                            {title}
                        </Heading>
                        <Text
                            textOverflow="ellipsis"
                            whiteSpace="nowrap"
                            overflow="hidden"
                            color="gray.500"
                            fontSize="sm"
                        >
                            {subtitle && `${subtitle} • `}
                            {t('mediaPlanning.scenarioCreation.dateLabel')}{' '}
                            {lastModified?.toLocaleString()}
                        </Text>
                    </>
                )}
            </VStack>
        </Stack>
    );
};
